import { getSessionJWT } from "@/infra/auth/helper";
import { getZaniaSocket } from "@/infra/sockets";
import { AgentSessionStepType, AgentSessionType } from "@/modules/sessions/types";
import { getAgentData } from "../states";
import { AGENT_TYPES } from "../types";
import { AgentSocketEvents } from "../types/events";
import { addNotification } from "@/shared/states/notification";
import { getAgentTask } from "../utils/agent-socket";

export const useControlApproval = (agentId: string) => {
  const socket = getZaniaSocket();

  const emitApproval = async (controlIds: string | string[]) => {
    try {
      const agentData = getAgentData(agentId);
      if (!agentData) return;

      const stepData = agentData.stepData;
      const editStepData = stepData?.find(
        (step) => step.type === AgentSessionStepType.EDIT_RESPONSE
      );

      const token = await getSessionJWT();

      socket.emit(
        AgentSocketEvents.CONTROL_APPROVED,
        {
          file_url: editStepData?.data?.url,
          agent_session_id: agentId,
          agent_session_step_id: editStepData?.id,
          control_ids: Array.isArray(controlIds) ? controlIds : [controlIds],
          task: getAgentTask(agentData),
        },
        
        (error: Error) => {
          if (error) {
            console.error("Socket emit error, Failed to approve response:", error);
          }
        }
      );
      addNotification({
        title: "Response accepted",
        message: "Loading next response..." ,
        type: "success",
      });

    } catch (error) {
      console.error("Error in emitApproval:", error);
      throw error;
    }
  };

  return { emitApproval };
};

//son